goog.provide('el8.ptdata.model.note.asSoyMap');

goog.require('el8.appservice.highlighter');
goog.require('el8.data.visitNoteTypes');
goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.vitalsCollections');
goog.require('el8.util.base');
goog.require('el8.util.format');


el8.ptdata.model.note.asSoyMap = function(item, editId) {

    /**
     * Super helpful helper functions for preparing
     * bullets to enter templates
     */
    function _parse(bulletSet) {
        return bulletSet.sorted(editId).map(function(a) {
            var m = {
                id: a.getId(),
                itemId: a.getDocumentId() || a.getHandoutId(),
                children: a.getChildrenSet().sorted(editId).map(
                    function(b) {
                        return {
                            id: b.getId(),
                            text: b.getText(),
                            itemId: b.getDocumentId(),
                            isReplaced: editId && (b.getReplacedByEditId() === editId),
                            isEdit: editId && (b.getEditId() === editId),
                            textReplaced: editId && (b.getEditId() === editId) ? a.getChildrenSet().getTextReplacedById(b.getId()) : ''
                        };
                    }
                ),
                isEdit: editId && (a.getEditId() === editId),
                isReplaced: editId && (a.getReplacedByEditId() === editId),
                textReplaced: editId && (a.getEditId() === editId) ? bulletSet.getTextReplacedById(a.getId()) : '',
                // Note that children bullets are never expected to use IMOs right now
                imos: a.getImoCodeObjs(true).map(el8.model.toSoyMapFn)
            };
            /**
             * Now, determine how to populate text -- if "text" or "text_formatting" are present, then
             * prioritize displaying those. Else, check if there's a document reference and display the
             * corresponding summary there
             *
             * NOTE: Still need to use safeText (rather than move el8.util.format into template) because
             * we need to rely on highlighter filter, which only works on strings. TODO Find better way to
             * implement highlighting
             */
            if (a.getTextFormatting()) {
                m['safeText'] = el8.util.format(a.getText(), a.getTextFormatting());

            } else if (a.getText()) {
                m['text'] = a.getText();

            } else if (a.getDocumentId()) {
                m['safeText'] = el8.util.format(a.getDocumentSummary(), a.getDocumentSummaryFormatting());
            }
            return m;
        });
    }

    function _parseSingleField(bulletSet) {
        var bullets = bulletSet.sorted(editId);
        var displayedText = [],
            replacedText = [];
        var isEdit = false;
        for (var i=0; i<bullets.length; i++) {
            var b = bullets[i];
            if (editId && (b.getReplacedByEditId() === editId)) {
                replacedText.push(b.getText());
            } else {
                displayedText.push(b.getText());
                if (editId) {
                    if (editId === b.getEditId()) {
                        isEdit = true; // stay as true
                        var replaced = bulletSet.getTextReplacedById(b.getId());
                        if (replaced) {
                            replacedText.push(replaced);
                        }
                    }
                }
            }
        }
        return {
            text: displayedText.join('; '),
            textReplaced: replacedText.join('; '),
            isEdit: isEdit
        };
    }

    if (item.is('NonvisitNote')) {

        var noteTypeName = el8.data.nonvisitNoteTypes.getByKey(
            item.getNoteTypeId()).getName();
        var bullets = item.getBulletSet().sorted().map(function(a) {
            if (a.getDocumentId()) {
                return {
                    triggerClass: 'item-details-trigger itemTrigger',
                    itemId: a.getDocumentId(),
                    text: (a.isTextSafe() || a.getTextFormatting()) ? null : a.getText(),
                    safeText: a.getTextFormatting() ?
                        el8.util.format(a.getText(), a.getTextFormatting()) :
                        (a.isTextSafe() ? a.getText() : null)
                };
            } else {
                return {
                    text: (a.isTextSafe() || a.getTextFormatting()) ? null : a.getText(),
                    safeText: a.getTextFormatting() ?
                        el8.util.format(a.getText(), a.getTextFormatting()) :
                        (a.isTextSafe() ? a.getText() : null)
                };
            }
        });
        var referencedDocs = item.getAssociatedDocuments().map(function(obj) {
            return {
                triggerClass: 'item-details-trigger itemTrigger',
                itemId: obj['document_id'],
                safeText: el8.util.format(obj['summary'], obj['summary_formatting'])
            };
        });
        var ownedDocs = item.getOwnedDocuments().map(function(obj) {
            return {
                triggerClass: 'item-details-trigger itemTrigger',
                itemId: obj['document_id'],
                safeText: el8.util.format(obj['summary'], obj['summary_formatting'])
            };
        });
        var vitalsCollections = item.getVitalsCollectionObjects().map(function(obj) {
            return {
                itemId: obj['id'],
                safeText: el8.template.ptdata.vitalsCollections.summary(obj.asSoyMap())
            };
        });
        return {
            modelClass: item.getModelClass(),
            id: item.getId(),
            feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
            signUserBehalfName : item.getSignUserBehalfName(),
            documentDate : el8.service.tz.soyStr(item.getDocumentDate()),
            deleteDate : el8.service.tz.soyStr(item.getDeleteDate()),
            signUserName : item.isSignedOff() ? item.getSignUserName() : null,
            signUserType: item.isSignedOff() ? item.getSignUserType() : null,
            originalAuthorUserName: item.getOriginalAuthorUserId() ?
                el8.data.referencedUsers.getById(item.getOriginalAuthorUserId()).getFullName() : null,
            signDate : el8.service.tz.soyStr(item.getSignDate()),
            typeName: noteTypeName.toLowerCase(),
            images: item.getImages(),
            bullets: bullets,
            referencedDocs: referencedDocs,
            ownedDocs: ownedDocs,
            vitalsCollections: vitalsCollections,
            attachments: item.getAttachments().map(function(a) {
                return a.asSoyMap();
            }),
            docTags: item.getDocTagMaps(),
            isConfidential: item.isConfidential(),
            isImportedNote: item.isImportedNote(),
            associatedEmail: item.getAssociatedEmail(),
            associatedXmlSummary: item.getAssociatedXmlSummary(),
            ccdaContentFileName: item.getCcdaContentFileName()
        };

    } else if (item.is('VisitNote')) {

        /**
         * First gather all the vitals
         */
        var prevVitals = {};
        prevVitals['weight'] = item.getPreviousWeight(editId) || null;
        prevVitals['bmi'] = item.getPreviousBmi(editId) || null;
        prevVitals['time'] = el8.service.tz.soyStr(item.getPreviousTime(editId));

        var _parseVitals = function(vitalsSet, fn) {
            if (!vitalsSet) { return null; }
            var sorted = vitalsSet.sorted(editId);
            var result = [];
            for (var i=0; i<sorted.length; i++) {
                var a = sorted[i];
                var soyMapped = fn.call(this, a) || '';
                // filter out any list items where all the dict values are falsy
                if (_.compact(_.values(soyMapped)).length) {
                    result.push({
                        val: soyMapped,
                        isEdit: editId && (a.getEditId() === editId),
                        isReplaced: editId && (a.getReplacedByEditId() === editId)
                    });
                }
            }
            return result;
        };
        var _latestVitals = item.getVitalsSets();

        // this soy map will leave out list items that are totally empty
        // (e.g., if hr and extraNote are both empty, that item will be left out)
        var vitals = {
            bp: _parseVitals(_latestVitals['bp'], function(a) {
                    return {
                        'bpD': a.getBpD(),
                        'bpS': a.getBpS(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            hr: _parseVitals(_latestVitals['hr'], function(a) {
                    return {
                        'hr': a.getHr(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            rr: _parseVitals(_latestVitals['rr'], function(a) {
                    return {
                        'rr': a.getRr(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            temp: _parseVitals(_latestVitals['temperature'], function(a) {
                    return {
                        'temp': a.getDisplayTemperature(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            pain: _parseVitals(_latestVitals['pain'], function(a) {
                    return {
                        'pain': a.getPain(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            ht: _parseVitals(_latestVitals['height'], function(a) {
                    return {
                        'ht': a.getDisplayHeight(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            wt: _parseVitals(_latestVitals['weight'], function(a) {
                    return {
                        'wt': a.getDisplayWeight(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            oxygen: _parseVitals(_latestVitals['oxygen'], function(a) {
                    return {
                        'oxygen': a.getPercent(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            hc: _parseVitals(_latestVitals['hc'], function(a) {
                    return {
                        'hc': a.getDisplayHc(),
                        'extraNote': a.getExtraNote()
                    };
                }),
            bmi: item.getBmi(editId),
            weightDelta: item.getWeightDelta(),
            bmiDelta: item.getBmiDelta(),
            prevVitals : prevVitals
        };
        if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) {
            var customGroups = el8.util.consts.ADDITIONAL_VITALS.map(function(customVital) {
                // max one value per custom vital type
                var values = _parseVitals(_latestVitals[customVital], function(a) {
                    return a.asSoyMap();
                });
                return values;
            });
            vitals.customObservations = _.compact(_.flatten(customGroups));
        }
        else {
            vitals.customObservations = [];
        }

        // Useful boolean for the templates
        var hasVitals = vitals.bp.length || vitals.hr.length || vitals.rr.length ||
                        vitals.temp.length || vitals.pain.length || vitals.ht.length ||
                        vitals.wt.length || vitals.oxygen.length || vitals.hc.length ||
                        (vitals.customObservations && vitals.customObservations.length);
        vitals['hasVitals'] = hasVitals;

        /**
         * Now collect all the other section data
         */

        var _parseDetails = function(currentChecklist, replacedChecklist) {

            var r = [];

            if (!currentChecklist || currentChecklist.isEmpty()) {
                currentChecklist = null;
            }
            if (!replacedChecklist || replacedChecklist.isEmpty()) {
                replacedChecklist = null;
            }

            var currentFields = currentChecklist ? currentChecklist.getFields() : [];
            var replacedFields = replacedChecklist ? replacedChecklist.getFields() : [];
            var fields = {};
            if (currentChecklist) {
                for (var i=0; i<currentFields.length; i++) {
                    var name = currentFields[i].getName();
                    fields[name] = true;
                    var currentVal = currentFields[i].getValue();
                    var replacedField = replacedChecklist ? replacedChecklist.getFieldByName(name) : null;
                    var replacedVal = replacedField ? replacedField.getValue() : '';
                    if (currentVal || replacedVal) {
                        var changed = (currentVal !== replacedVal);
                        r.push({
                            choice: name,
                            value: currentVal,
                            valueReplaced: changed ? replacedVal : '',
                            isEdit: (editId && changed && (editId === currentChecklist.getEditId()))
                        });
                    }
                }
            }
            if (replacedChecklist) {
                // This is to snag fields in the replacedChecklist that aren't in the currentChecklist
                // (i.e. have been deleted). All these will get put at the end (don't have sequence in currentChecklist)
                for (var i=0; i<replacedFields.length; i++) {
                    var name = replacedFields[i].getName();
                    var value = replacedFields[i].getValue();
                    if (value && !fields[name]) {
                        r.push({
                            choice: name,
                            value: '',
                            valueReplaced: value,
                            isEdit: true
                        });
                    }
                }
            }

            return r;
        };

        var peDetailsLists = item.getChecklists('pe', editId);
        var peDetails = _parseDetails(peDetailsLists.current, peDetailsLists.replaced);

        var objective = {
            objectives : _parse(item.getBulletSets()['Objective']),
            allDatas : _parse(item.getBulletSets()['Data']),
            peDetails : peDetails,
            peItems : _parse(item.getBulletSets()['Pe']),
            vitals: vitals,
            referenceds : _parse(item.getBulletSets()['Referenced'])
        };

        var assessment = {
            assessplans: _parse(item.getBulletSets()['Assessplan']),
            assessments: _parse(item.getBulletSets()['Assessment'])
        };

        var plan = {
            plans : _parse(item.getBulletSets()['Plan']),
            tests : _parse(item.getBulletSets()['Test']),
            txs : _parse(item.getBulletSets()['Tx']),
            instructions : _parse(item.getBulletSets()['Instr']),
            orders : _parse(item.getBulletSets()['Orders']),
            procedures: _parse(item.getBulletSets()['Procedure'])
        };

        var rosDetailsLists = item.getChecklists('ros', editId);
        var rosDetails = _parseDetails(rosDetailsLists.current, rosDetailsLists.replaced);

        var subjective = {
            narrative: _parseSingleField(item.getBulletSets()['Narrative']), // Assume is always a single field
            allergies : _parse(item.getBulletSets()['Allergies']),
            hpiItems : _parse(item.getBulletSets()['Hpi']),
            pastItems : _parse(item.getBulletSets()['Past']),
            surgicalItems : _parse(item.getBulletSets()['Surgical']),
            familyItems : _parse(item.getBulletSets()['Family']),
            socialItems : _parse(item.getBulletSets()['Social']),
            habitsItems : _parse(item.getBulletSets()['Habits']),
            vniMeds : _parse(item.getBulletSets()['Med']),
            rosItems : _parse(item.getBulletSets()['Ros']),
            rosDetails : rosDetails,
            problems: _parse(item.getBulletSets()['Problem'])
        };

        var formattedFeedDate = item.getDisplayDate().asString() + ' ' +
            item.getDisplayDate().getDayName(true) + ' ' +
            item.getDisplayDate().asTimeString();

        var edits = item.getEdits().map(function(e) { return e.asSoyMap(); });
        if (editId) {
            var ordering = item.getEditsOrdering();
            edits = edits.filter(function(a) { return (ordering[a.id] <= ordering[editId]); });
        }

        var description = editId ? item.getDescription(item.getNoteTypeId(editId)) : item.getDescription();

        var noteTypeId = editId ? item.getNoteTypeId(editId) : item.getNoteTypeId();
        var noteType = el8.data.visitNoteTypes.getByIdIncludingDeleted(noteTypeId);
        var noteTypeMap = noteType ? noteType.asSoyMap() : '';

        var template = item.getTemplate();
        if (!template) {
            // leave this here as stopgap because a non-intentionally empty template may cause issues
            // (only intentional ones are ones without images)
            template = el8.util.consts.DEFAULT_VISIT_NOTE_TEMPLATE;
        }

        /* el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] is only setup on patient chart page */
        var templateTypeMap = el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'] ?
            el8Globals['VISIT_NOTE_SECTION_TYPE_MAP'][template] : {};

        return {
            modelClass: item.getModelClass(),
            id: item.getId(),
            feedDate: el8.service.tz.soyStr(item.getDisplayDate()),
            formattedFeedDate: formattedFeedDate,
            signUserBehalfName : item.getSignUserBehalfName() || null,
            signUserName : item.isSignedOff() ? item.getSignUserName() : null,
            signDate : el8.service.tz.soyStr(item.getSignDate()),
            signatures: item.getSignatures(),
            deleteUserName : item.isDeleted() ? el8.data.referencedUsers.getById(item.getDeleteUserId()).getFullName() : null,
            documentDate : el8.service.tz.soyStr(item.getDocumentDate(editId)),
            deleteDate : el8.service.tz.soyStr(item.getDeleteDate()),
            description: description,
            template: item.getTemplate(),
            templateClass: item.getTemplateClass(),
            templateTypeMap: templateTypeMap,
            headerSummary: item.getHeaderSummary(),
            images : item.getImages(),
            dateprocedure: _parseSingleField(item.getBulletSets()['Dateprocedure']),
            consultant: _parseSingleField(item.getBulletSets()['Consultant']),
            attending: _parseSingleField(item.getBulletSets()['Attending']),
            reason: _parseSingleField(item.getBulletSets()['Reason']),
            age : item.getDisplayPatientAge(),
            objective : objective,
            assessment : assessment,
            plan : plan,
            subjective : subjective,
            bill : item.getBill() ? item.getBill().asSoyMap() : null,
            timeWithPatient : item.getTimeWithPatient() ? el8.util.string.renderTime(item.getTimeWithPatient()) : null,
            timeDocumenting : item.getTimeDocumenting() ? el8.util.string.renderTime(item.getTimeDocumenting()) : null,
            checkout : item.getCheckout() ? item.getCheckout().getSummary() : null,
            muInfo : item.getMeaningfulUseInfo() ? item.getMeaningfulUseInfo().asSoyMap() : null,
            amendmentRequest : item.getAmendmentRequest() ? item.getAmendmentRequest().asSoyMap() : null,
            followup : _parseSingleField(item.getBulletSets()['Followup']),
            edits : edits,
            type: noteTypeMap,
            attachments: item.getAttachments().map(el8.model.toSoyMapFn),
            physicianFullName: item.getPhysicianFullName(),
            docTags: item.getDocTagMaps(),
            isConfidential: item.isConfidential(),
            isImportedNote: item.isImportedNote()
        };
    }

    return null;
};
